import { UserProfile } from 'api/account/models/UserProfile';
import { CatalogBrandsSearchCriteria } from 'api/catalog/models/CatalogBrandsSearchCriteria';
import { CatalogModelsSearchCriteria } from 'api/catalog/models/CatalogModelsSearchCriteria';
import SuppliersService from 'api/suppliers/SuppliersService';
import UsersService from 'api/users/UsersService';
import VehicleBrandsService from 'api/vehicleBrands/VehicleBrandsService';
import VehicleModelsService from 'api/vehicleModels/VehicleModelsService';
import { VehicleCondition } from 'api/vehicles/enums/VehicleCondition';
import { VehicleDto } from 'api/vehicles/models/VehicleDto';
import { VehicleViewModel } from 'api/vehicles/models/VehicleViewModel';
import VehiclesService from 'api/vehicles/VehiclesService';
import VehicleSegmentsService from 'api/vehicleSegments/VehicleSegmentsService';
import IconBack from 'assets/svg/Arrow-grey.svg';
import Box from 'common/components/box/Box';
import Button from 'common/components/button/Button';
import DateTimePickerController from 'common/components/dateTimePicker/DateTimePickerController';
import FormItem from 'common/components/formItem/FormItem';
import InputController from 'common/components/input/InputController';
import InputError from 'common/components/inputError/InputError';
import InputGroup from 'common/components/inputGroup/InputGroup';
import QuestionYesNo from 'common/components/questionYesNo/QuestionYesNo';
import SelectController from 'common/components/select/SelectController';
import CustomFile from 'common/models/CustomFile';
import Loading from 'common/services/Loading';
import Logger from 'common/services/Logger';
import Utils from 'common/services/Utils';
import { SelectValueLabel } from 'common/types/SelectValueLabel';
import { DATE_FORMAT_DEFAUT, DEFAULT_INPUT_RULES_WITH_REQUIRED, FUELS, LOGGER_LOG_TYPE, SEGMENT_FEATURES, removeAccents } from 'Config';
import React, { useEffect, useMemo, useState } from 'react';
import { Col, Row } from 'react-flexbox-grid';
import { Controller, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { FaCalendarAlt } from 'react-icons/fa';
import { useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import { useToasts } from 'react-toast-notifications';
import { Types as CloseType } from 'screens/vehicle/VehicleScreen';
import { Reducers } from 'store/types';
import styles from './CarForm.module.scss';
import TechnicalInformationForm from './technicalInformationForm/TechnicalInformationForm';
import Label from 'common/components/label/Label';
import DriversService from 'api/drivers/DriversService';
import ToggleSwitch from 'common/components/toggleSwitch/ToggleSwitch';
import MediaSelector from 'common/components/mediaSelector/MediaSelector';
import QrCode from 'common/components/qrCode/QRCode';
import Select from 'common/components/select/Select';
import { LocalBasicInfoViewModel } from 'api/locals/models/LocalViewModel';
import LocalsService from 'api/locals/LocalsService';
import VehicleFuelForm from './vehicleFuelForm/VehicleFuelForm';
import Input from 'common/components/input/Input';
import LoadingSpinner from 'common/components/loading/LoadingSpinner';
import { CatalogSegmentsSearchCriteria } from 'api/catalog/models/CatalogSegmentsSearchCriteria';
import GpsLocatorsService from 'api/gpsLocators/GpsLocatorsService';
import { VehicleSegmentSelectValueLabel } from 'api/vehicleSegments/models/VehicleSegmentDto';
import TrackingService from 'api/tracking/TrackingService';
import TrackingVehicle from 'api/tracking/models/TrackingVehicle';
import AdditionalDataForm from 'screens/additional-data/additionalDataForm/AdditionalDataForm';
import AdditionalDataService from 'api/additional-data/AdditionalDataService';
import { AdditionalDataViewModel } from 'api/additional-data/models/AdditionalDataViewModel'; 
import { FaAngleDown, FaAngleUp } from 'react-icons/fa';
import colors from 'styles/export/colors.module.scss';
import VehicleReplacementModal from '../vehicleReplacementModal/VehicleReplacementModal'
import ReplacementTimeline from './replacementTimeline/ReplacementTimeline';
import VehicleActivationModal from './vehicleActivationModal/VehicleActivationModal';
import DateFormat from 'common/components/dateFormat/dateFormat';

type Props = {
    item?: VehicleViewModel;
    mode?: string;
    onCancel: (value?: CloseType, id?: any) => void;
    onVehicleUpdated?: () => void | undefined;
    itemOriginal?: VehicleViewModel;
    setItem?: (i: VehicleViewModel) => void;
} & React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>;

const CarForm: React.FC<Props> = ({ item, mode, onCancel, onVehicleUpdated, itemOriginal, setItem }: Props) => {
    const { t } = useTranslation();
    const { addToast } = useToasts();

    const form = useForm<VehicleViewModel>({ shouldUnregister: false, defaultValues: item ? item : { vehicleFuels: [] } });
    const { handleSubmit, setValue, control, register, errors, watch, getValues } = form;
    const history = useHistory();

    const { returnUrl } = useParams<{ returnUrl: string }>();

    const [segmentFeatures, setSegmentFeatures] = useState<string[]>([]);
    const [localsOptions, setLocalsOptions] = useState<SelectValueLabel[]>([]);
    const [brandsOptions, setBrandsOptions] = useState<SelectValueLabel[]>([]);
    const [modelsOptions, setModelsOptions] = useState<SelectValueLabel[]>([]);
    const [typesOptions, setTypesOptions] = useState<VehicleSegmentSelectValueLabel[]>([]);
    const [fuelsOptions, setFuelsOptions] = useState<SelectValueLabel[]>([]);
    const [fuelSuppliersOptions, setFuelSuppliersOptions] = useState<SelectValueLabel[]>([]);
    const [colorsOptions, setColorsOptions] = useState<SelectValueLabel[]>([]);
    const [trackingVehiclesOptions, setTrackingVehiclesOptions] = useState<SelectValueLabel[]>([]);
    const [trackingVehiclesById, setTrackingVehiclesById] = useState<Record<string, TrackingVehicle>>({});
    const [gpsDeviceConflictMessage, setGpsDeviceConflictMessage] = useState<string | undefined>(undefined);
    const [gpsDeviceInactiveWarning, setGpsDeviceInactiveWarning] = useState<string | undefined>(undefined);
    const [isLoadingVehicles, setIsLoadingVehicles] = useState<boolean>(false);

    const [selectedCondition, setSelectedCondition] = useState<string>('');
    const [conditionIsSelected, setConditionIsSelected] = useState<boolean>(true);
    const [medias, setMedias] = useState<CustomFile[]>([]);

    const [itemToRemove, setItemToRemove] = useState<VehicleViewModel>();
    const [itemToActivate, setItemToActivate] = useState<VehicleViewModel>();
    const [dialogDeleteItemIsOpen, setDialogDeleteItemIsOpen] = React.useState(false);
    const [dialogActivateItemIsOpen, setDialogActivateItemIsOpen] = React.useState(false);
    const [registrationAlreadyExists, setRegistrationAlreadyExists] = useState<string | undefined>(undefined);

    const userProfile = useSelector<Reducers, UserProfile | null>(state => state.authentication.profile);
    const hasVehiclesWritePolicy = UsersService.hasPolicies(userProfile?.policies || [], ['SETTINGUP_VEHICLES_WRITE']);
    const [driversOptions, setDriversOptions] = useState<SelectValueLabel[]>([]);

    const [technicalInformationsIdsToRemove, setTechnicalInformationsIdsToRemove] = useState<string[]>([]);

    const conditionsOptions: VehicleCondition[] = [
        VehicleCondition.NEW,
        VehicleCondition.USED
    ];

    const [gpsLocatorsOptions, setGpsLocatorsOptions] = useState<SelectValueLabel[]>([]);
    const [reRender, setReRender] = useState<number>(1);
    const [initial, setInitial] = useState<AdditionalDataViewModel[]>([]);

    const [dialogReplacementVehicleIsOpen, setDialogReplacementVehicleIsOpen] = useState<boolean>(false);
    const [replacementVehiclesRowExpanded, setReplacementVehiclesRowExpanded] = useState<boolean>(false);
    const [dialogQuestionFinishReplacementVehicleIsOpen, setDialogQuestionFinishReplacementVehicleIsOpen] = useState<boolean>(false);
    const [isDetails, setIsDetails] = useState<boolean>(mode === 'details');

    const getData = async () => {
        Loading.show();
        try {
            const [
                brands,
                models,
                types,
                fuels,
                fuelSuppliers,
                colors,
                drivers,
                locals,
                gpsLocators
            ] = await Promise.all([
                VehicleBrandsService.catalog(),
                VehicleModelsService.catalog(),
                VehicleSegmentsService.catalog(),
                VehiclesService.getFuelList(),
                SuppliersService.getFuelSuppliers(),
                VehiclesService.getColorsList(),
                item?.id ? DriversService.catalogAvailableForVehicle(item.id, item.driverId) : DriversService.catalog(),
                LocalsService.catalog(),
                GpsLocatorsService.GetAllForSelectItem()
            ]);

            setBrandsOptions(brands);
            setModelsOptions(models);
            setTypesOptions(types);
            setFuelsOptions(Utils.sortAlphabetically(fuels.map(x => ({ value: x.value, label: (t(('vehicle.fuels.' + x.label) as any)), fullLabel: x.label }))));
            setFuelSuppliersOptions(fuelSuppliers);
            setColorsOptions(Utils.sortAlphabetically(colors.map(x => ({ value: x.value, label: (t(('vehicle.colors.' + x.label) as any)) }))));

            setLocalsOptions(locals);

            setGpsLocatorsOptions(gpsLocators);

            // #66345: o repescar do condutor em falta passou para o useMemo driversOptionsWithCurrent,
            // porque este catálogo só é carregado no mount e o item muda ao abrir um snapshot histórico.
            setDriversOptions(drivers);

            if (item) {
                getSegmentFeatures();
                setSelectedCondition(item.condition);
                if (selectedCondition && selectedCondition != '') {
                    setConditionIsSelected(true);
                }

                if (item.gpsLocatorId) {
                    await loadGpsVehicles(item.gpsLocatorId);
                }
            }
            else {
                const additionalData = await AdditionalDataService.getByType('VEHICLE');
                setInitial(additionalData.map(x => {
                    return { 'additionalDataId': x.id ?? '', 'type': x.type, 'designation': x.designation };
                }));
                setReRender(x => x + 1);
            }

            Loading.hide();
        } catch (error) {
            Logger.error(LOGGER_LOG_TYPE.VEHICLES, `Couldn't get information to create vehicle`, error);
            addToast(t('common.messages.error_load_info'), { appearance: 'error' });
            Loading.hide();
        }
    }

    const loadHistory = async (idVehicleHistory: string) => {
        if(setItem)
        { 
            const vm = await VehiclesService.getVehicleHistoryById(idVehicleHistory);
            const newItem = { 
                //...itemOriginal,
                vehicleHistoryId: vm.vehicleHistoryId,
                registrationNumber: vm.registrationNumber,
                vehicleBrandId: vm.vehicleBrandId,
                vehicleBrandName: vm.vehicleBrandName,
                vehicleModelId: vm.vehicleModelId,
                vehicleModelName: vm.vehicleModelName,
                vehicleSegmentId: vm.vehicleSegmentId,
                vehicleSegmentName: vm.vehicleSegmentName, 
                condition: vm.condition, 
                colorId: vm.colorId, 
                colorName: vm.colorName, 
                photoId: vm.photoId, 
                photoUrl: vm.photoUrl, 
                photoName: vm.photoName, 
                photo: vm.photo,
                currentKilometers: vm.currentKilometers, 
                currentKilometersTracking: vm.currentKilometersTracking, 
                lastKilometersUpdate: vm.lastKilometersUpdate, 
                trackingDeviceId: vm.trackingDeviceId, 
                companyTrackingProvider: vm.companyTrackingProvider,   
                fuelCard: vm.fuelCard, 
                fuelCardSupplierId: vm.fuelCardSupplierId, 
                fuelCardSupplierName: vm.fuelCardSupplierName, 
                averageTargetMonth: vm.averageTargetMonth,
                averageTargetMonthHours: vm.averageTargetMonthHours,
                currentHours: vm.currentHours,
                fiscalPower: vm.fiscalPower,
                dateCirculation: vm.dateCirculation, 
                reservationAvailable: vm.reservationAvailable, 
                defaultDriverId: vm.defaultDriverId, 
                gpsLocatorId: vm.gpsLocatorId, 
                driverId: vm.driverId,  
                driverName: vm.driverName,
                driverPhotoUrl: vm.driverPhotoUrl,
                active: vm.active,
                vehicleSegmentDefaultPhotoUrl: vm.vehicleSegmentDefaultPhotoUrl,
                historyCreatedDate: vm.historyCreatedDate,
                vehicleLocals: vm.vehicleLocals,
                additionalData: vm.additionalData,
                timelineHistory: itemOriginal ? itemOriginal.timelineHistory : undefined,
                activeDescription: vm.active ? t('vehicle.vehicle_active') : t('vehicle.vehicle_inactive')
                //vehicleFuels: undefined,
                //technicalInformations: undefined
            } as VehicleDto;
            setItem(newItem);
            setSelectedCondition(newItem.condition);
            getSegmentFeatures();
            setIsDetails(true); 
        }
    }

    const resetItemToOriginal = () => {
        if(setItem && itemOriginal){
            setIsDetails(mode === 'details');
            setItem(itemOriginal);
            setTimeout(() => {
                setSelectedCondition(itemOriginal.condition);
                getSegmentFeatures();    
            }, 150)
        }
    }

    const loadGpsVehicles = async (gpsLocatorId: string) => {
        try {
            const trackingVehicles = await TrackingService.getVehiclesByLocator(gpsLocatorId, item?.id)
            setIsLoadingVehicles(false);
            const byId: Record<string, TrackingVehicle> = {};
            trackingVehicles.forEach(v => { byId[v.id] = v; });
            setTrackingVehiclesById(byId);

            const visible = trackingVehicles
                .filter(v => !v.assignedToActive || v.id === item?.trackingDeviceId)
                .map(v => ({
                    value: v.id,
                    label: v.assignedToInactive
                        ? `${v.name} (${t('vehicle.vehicle_inactive')})`
                        : v.name
                }));
            setTrackingVehiclesOptions(Utils.sortAlphabetically(visible));
            setIsLoadingVehicles(false);
        } catch (err) {
            addToast(`${t('common.errors.tracking_auth')}. \n${t('common.messages.contact_admin')}`, { appearance: 'warning' });
            Logger.error(LOGGER_LOG_TYPE.CHARGES, `Provider Authentication Error - wrong credencials`, err);
            setIsLoadingVehicles(false);
        }
    }

    const getSegmentFeatures = async () => {
        try {
            const features = await VehicleSegmentsService.getFeatures(form.getValues('vehicleSegmentId'));
            setSegmentFeatures(features);
        } catch (error) {
            Logger.error(LOGGER_LOG_TYPE.VEHICLES, `Couldn't get segment features`, error);
            addToast(t('common.messages.error_load_info'), { appearance: 'error' });
        }
    }

    const getSegmentsByBrand = async (brandId?: string) => {
        try {
            const segments = await VehicleSegmentsService.catalog({ brandId } as CatalogSegmentsSearchCriteria);
            setTypesOptions(segments);

            if (!form.getValues('vehicleSegmentId') && segments.length == 1) {
                setValue('vehicleSegmentId', segments.find(x => x.value)?.value);
            }
        } catch (error) {
            Logger.error(LOGGER_LOG_TYPE.VEHICLES, `Couldn't get segments by brand`, error);
            addToast(t('common.messages.error_load_info'), { appearance: 'error' });
        }
    }

    const getBrandsBySegment = async () => {
        getSegmentFeatures();
        try {
            const brands = await VehicleBrandsService.catalog({ segmentId: form.getValues('vehicleSegmentId') } as CatalogBrandsSearchCriteria);
            setBrandsOptions(brands);

            if (form.getValues('vehicleSegmentId') && !brands?.length) {
                setModelsOptions([]);
                setValue('vehicleBrandId', null);
                setValue('vehicleModelId', null);
                return;
            }

            if (!form.getValues('vehicleBrandId') && brands.length == 1) {
                const brand = brands.find(x => x.value)?.value
                setValue('vehicleBrandId', brand);
                getModelByBrand(brand);
            }
        } catch (error) {
            Logger.error(LOGGER_LOG_TYPE.VEHICLES, `Couldn't get brands of segment`, error);
            addToast(t('common.messages.error_load_info'), { appearance: 'error' });
        }
    }

    const getBrandByModel = async () => {
        try {
            const brand = await VehicleBrandsService.catalog({ modelId: form.getValues('vehicleModelId') } as CatalogBrandsSearchCriteria);
            setBrandsOptions(brand);

            let brandId = form.getValues('vehicleBrandId');
            if (!brandId && brand.length == 1) {
                brandId = brand.find(x => x.value)!.value
                setValue('vehicleBrandId', brandId);
                getModelByBrand();
            }
            getSegmentsByBrand(brandId);
        } catch (error) {
            Logger.error(LOGGER_LOG_TYPE.VEHICLES, `Couldn't get brands of model`, error);
            addToast(t('common.messages.error_load_info'), { appearance: 'error' });
        }
    }

    const getModelByBrand = async (brandId?: string) => {
        if (form.getValues('vehicleSegmentId') && !brandsOptions?.length && !brandId) {
            setModelsOptions([]);
            return;
        }

        brandId = brandId || form.getValues('vehicleBrandId');

        try {
            const models = await VehicleModelsService.catalog({ brandId } as CatalogModelsSearchCriteria);
            setModelsOptions(models);

            if (!form.getValues('vehicleModelId') && models.length == 1) {
                setValue('vehicleModelId', models.find(x => x.value)?.value);
                if (!brandId) {
                    getBrandByModel();
                }
            }
        } catch (error) {
            Logger.error(LOGGER_LOG_TYPE.VEHICLES, `Couldn't get models of brand`, error);
            addToast(t('common.messages.error_load_info'), { appearance: 'error' });
        }
    }

    // Task #66078: after saving, push the capacity to GPSTracking. Non-fatal — never blocks the save.
    const pushCapacityToGps = async (vehicleId: string | undefined, form: VehicleViewModel) => {
        if (!vehicleId || !form.gpsLocatorId || !form.trackingDeviceId) return;
        try {
            await TrackingService.pushVehicleCapacity(vehicleId, form.tankCapacity, form.batteryCapacityKwh);
        } catch (err) {
            Logger.error(LOGGER_LOG_TYPE.VEHICLES, `Couldn't push vehicle capacity to GPS`, err);
        }
    };

    const onSubmit = async (form: VehicleViewModel) => {

        const mediasToSubmit: CustomFile[] = [];

        try {
            if (!selectedCondition) {
                setConditionIsSelected(false);
            }

            if ((!form.vehicleSegmentId || !typesOptions.find(x => x.value === form.vehicleSegmentId))
                || !form.registrationNumber
                || !selectedCondition
                || (showField(SEGMENT_FEATURES.FUEL) && !form.vehicleFuels?.filter(x => x.fuelId)?.length)
            ) {
                addToast(t('common.messages.complete_required_fields'), { appearance: 'warning' });
                return;
            }

            // if (form.trackingDeviceId){
            //     const registration = trackingDevices.filter(device => device.value === form.trackingDeviceId)[0];
            //     if (form.registrationNumber.toLowerCase() != registration.label.toLowerCase()){

            //          const regLabel = showField(SEGMENT_FEATURES.KM) ? t('vehicle.registration') : t('vehicle.identification')
            //           addToast(t('common.messages.gps_device_invalid',{ regLabel }), { appearance: 'warning' });
            //           return;
            //     }
            // }


            let fuelsRepeated = false;
            if ((form.vehicleFuels?.length ?? 0) > 1) {
                form.vehicleFuels?.forEach((x, i) => {
                    if (!fuelsRepeated) {
                        fuelsRepeated = (form.vehicleFuels?.filter(z => z.fuelId == x.fuelId)?.length ?? 0) > 1;
                    }
                })

                if (fuelsRepeated) {
                    addToast(t('vehicle.fuels_repeated'), { appearance: 'warning' });
                    return;
                }
            }

            Loading.show();

            const model: VehicleDto = {
                id: form.id,
                registrationNumber: form.registrationNumber,
                registrationNumberDate: form.registrationNumberDate,
                vehicleBrandId: form.vehicleBrandId,
                vehicleModelId: form.vehicleModelId,
                vehicleSegmentId: form.vehicleSegmentId,
                condition: selectedCondition,
                colorId: form.colorId,
                removeAttachment: form.removeAttachment,
                currentKilometers: form.currentKilometers,
                trackingDeviceId: form.trackingDeviceId,
                totalCostCharges: form.totalCostCharges,
                totalCostMaintenances: form.totalCostMaintenances,
                totalCostContracts: form.totalCostContracts,
                fuelCard: form.fuelCard,
                fuelCardSupplierId: form.fuelCardSupplierId,
                averageTargetMonth: form.averageTargetMonth,
                averageTargetMonthHours: form.averageTargetMonthHours,
                tankCapacity: form.tankCapacity,
                batteryCapacityKwh: form.batteryCapacityKwh,
                dailyKmLimit: form.dailyKmLimit,
                currentHours: form.currentHours,
                fiscalPower: form.fiscalPower,
                dateCirculation: form.dateCirculation,
                reservationAvailable: form.reservationAvailable ?? false,
                defaultDriverId: form.defaultDriverId,
                technicalInformations: form.technicalInformations,
                vehicleLocals: form.vehicleLocals,
                vehicleFuels: showField(SEGMENT_FEATURES.FUEL) ? form.vehicleFuels : undefined,
                gpsLocatorId: form.gpsLocatorId,
                active: true,
                additionalData: form.additionalData,
            };

            if (form.technicalInformations) {
                form.technicalInformations.forEach(ti => {
                    ti.attachments.forEach(a => {
                        mediasToSubmit.push(a);
                    })
                })
            }
            if (form.photo) {
                form.photo.forEach(p => {
                    mediasToSubmit.push(p);
                })
            }

            const tempModel = { ...model, technicalInformationsIdsToRemove };

            if (!item) {
                const createId = await VehiclesService.create(tempModel, mediasToSubmit);
                await pushCapacityToGps(createId, form);
                addToast(t('common.messages.record_save_success'), { appearance: 'success' });
                navigateTo('details', createId);
            } else {
                model.id = item.id;
                await VehiclesService.update(tempModel, mediasToSubmit);
                await pushCapacityToGps(item.id, form);
                addToast(t('common.messages.record_save_success'), { appearance: 'success' });
                navigateTo();
            }

            Loading.hide();
        } catch (error) {
            Loading.hide();

            if (error?.response?.status === 409) {
                if (error?.response?.data?.code === 'GPS_DEVICE_IN_USE') {
                    const message = error.response.data.message as string;
                    setGpsDeviceConflictMessage(message);
                    addToast(message, { appearance: 'warning' });
                    return;
                }
                addToast(showField(SEGMENT_FEATURES.KM) ? t('common.messages.registration_number_already_exists') : t('common.messages.indentification_number_already_exists'), { appearance: 'warning' });
                setRegistrationAlreadyExists(form.registrationNumber);
                return;
            }

            if (error?.response?.status === 402) {
                addToast(t('common.errors.pack_limit_exceeded'), { appearance: 'warning' });
                return;
            }

            addToast(t('common.messages.record_save_error'), { appearance: 'error' });
        }
    };

    const navigateTo = (type?: string, id?: string) => {
        if (mode == 'edit') { 
            if (Boolean(item)) {
                //form.reset(item);
                getData();
                //filterTrackingDevices();
            }
            onCancel(mode, item?.id);
            setIsDetails(true);
        }
        else { 
            if (type) {
                setIsDetails(type === 'details');
                history.push(`/vehicles/${type}/${id}`);
            } else {
                if (returnUrl) {
                    history.push(`/${returnUrl}`);
                } else {
                    history.push(`/vehicles`);
                    setIsDetails(true);
                }
            }
        }
    }

    const renderConditionItem = (name: string, onClick: () => void, isSelected: boolean, key: number) => (
        <div
            onClick={(onClick)}
            key={`condition-${key}`}
            style={{ width: '50%' }}
        >
            <div className={styles.labelContainer}>
                <div className={` ${(isSelected ? styles.selected : styles.notSelected)} ${styles.labelContent}`}>
                    <span>{name}</span>
                </div>
            </div>
        </div>
    );

    const onSelectCondition = (type: any) => {
        if(isDetails) return;

        if (mode !== 'details' && type) {
            setSelectedCondition(type || null);
        }
        if (item) {
            item.condition == type;

            if (type == VehicleCondition.NEW) {
                item.condition = VehicleCondition.USED;
            }
        }
        onSubmit;
    }

    const showRemoveItemDialog = (_item: VehicleViewModel) => {
        setItemToRemove(_item);
        setDialogDeleteItemIsOpen(true);
    };

    const removeItem = async (): Promise<boolean> => {
        setDialogDeleteItemIsOpen(false);
        if (itemToRemove) {
            try {
                Loading.show();
                await VehiclesService.remove(itemToRemove);
                addToast(t('common.messages.record_deactivate_success'), { appearance: 'success' });
                onVehicleUpdated && onVehicleUpdated();
                Loading.hide();
                return true;
            } catch (error) {
                addToast(t('common.messages.record_deactivate_error'), { appearance: 'error' });
                Loading.hide();
                return false;
            }
        }
        return false;
    };

    const deactivateAndReplaceItem = async () => {
        const success = await removeItem();
        if (success) {
            setDialogReplacementVehicleIsOpen(true);
        }
    };

    const activateAndFinishReplaceItem = async () => {
        const success = await activateItem();
        if (success) {
            setDialogReplacementVehicleIsOpen(true);
        }
    };

    const showActivateItemDialog = (_item: VehicleViewModel) => {
        setItemToActivate(_item);
        setDialogActivateItemIsOpen(true);
    };


    const activateItem = async (): Promise<boolean> => {
        setDialogActivateItemIsOpen(false);
        if (itemToActivate) {
            try {
                Loading.show();
                await VehiclesService.activate(itemToActivate);
                addToast(t('common.messages.record_activate_success'), { appearance: 'success' });
                onVehicleUpdated && onVehicleUpdated();
                Loading.hide();
                return true;
            } catch (error) {
                Loading.hide();
                if (error?.response?.status === 402) {
                    addToast(t('common.errors.pack_limit_exceeded'), { appearance: 'warning' });
                    return false;
                }
                addToast(t('common.messages.record_activate_error'), { appearance: 'error' });
                return false;
            }
        }
        return false;
    };

    const onAddMedias = (_medias: CustomFile[]) => {
        setMedias(_medias);
        setValue('photo', _medias);
    }

    const onRemoveMedia = (mediaId: string) => {
        // mediaId is not enough because after submit and getData, mediaId that come from db is different than submited mediaId
        const filteredMedia = [...medias.filter(x => x.id != mediaId && x.containerName != 'vehiclePhoto')];
        setValue('photo', filteredMedia);
        setValue('removeAttachment', true);
        setMedias(filteredMedia);
    }

    const onRemoveTechnicalInformation = (id: string) => {
        if (id) {
            setTechnicalInformationsIdsToRemove([...technicalInformationsIdsToRemove, id]);
        }
    }

    const showField = (feature: string) => {
        return (segmentFeatures?.findIndex(x => x == feature) ?? -1) >= 0;
    }

    // #66078: detetar combustíveis selecionados para mostrar capacidade do depósito (não elétrico) vs bateria (elétrico)
    const selectedFuelFullLabels = (form.watch('vehicleFuels') ?? [])
        .map(vf => fuelsOptions.find(o => o.value === vf?.fuelId)?.fullLabel)
        .filter(x => !!x);
    const hasElectricFuel = selectedFuelFullLabels.some(x => x === FUELS.ELECTRIC);
    const hasNonElectricFuel = selectedFuelFullLabels.some(x => x !== FUELS.ELECTRIC);

    // #66345: driversOptions é carregado uma única vez no mount e o catálogo só devolve condutores
    // ativos e associáveis a este ativo. Ao abrir um snapshot histórico o item muda e o condutor
    // dessa data pode já não constar (eliminado, reatribuído) — o select ficava em branco apesar de
    // o nome vir na API. Injetamos aqui a opção em falta em vez de mexer no estado.
    const driversOptionsWithCurrent = useMemo(() => {
        const driverId = item?.defaultDriverId;
        const driverName = item?.driverName;
        if (!driverId || !driverName || driversOptions.some(x => x.value == driverId)) {
            return driversOptions;
        }
        return Utils.sortAlphabeticallyByKey(
            [{ value: driverId, label: driverName }, ...driversOptions],
            'label'
        );
    }, [driversOptions, item?.defaultDriverId, item?.driverName]);

    useEffect(() => {
        getData();
    }, []);

    useEffect(() => {
        form.reset(item);
    }, [item]);

    // #66345: só limpar quando o ativo fica disponível para reserva (aí o campo é desativado e tem
    // de ficar vazio). Sem esta guarda, o efeito também corria no mount e ao carregar um snapshot
    // histórico com reservationAvailable diferente, apagando o condutor logo a seguir ao form.reset.
    useEffect(() => {
        if (form.watch('reservationAvailable')) {
            form.setValue('defaultDriverId', undefined);
        }
    }, [form.watch('reservationAvailable')]);


    useEffect(() => {
        const locator = form.watch('gpsLocatorId');
        if (locator) {
            loadGpsVehicles(locator).catch(console.error);
        } else {
            form.setValue('trackingDeviceId', undefined);
            setTrackingVehiclesOptions([]);
            setTrackingVehiclesById({});
            setGpsDeviceInactiveWarning(undefined);
            setGpsDeviceConflictMessage(undefined);
        }
    }, [form.watch('gpsLocatorId')]);

    useEffect(() => {
        const trackingDeviceId = form.watch('trackingDeviceId');
        setGpsDeviceConflictMessage(undefined);
        if (!trackingDeviceId) {
            setGpsDeviceInactiveWarning(undefined);
            return;
        }
        const tv = trackingVehiclesById[trackingDeviceId];
        if (tv?.assignedToInactive && trackingDeviceId !== item?.trackingDeviceId) {
            setGpsDeviceInactiveWarning(t('vehicle.gps_device_in_use_inactive', { name: tv.assignedToVehicleName ?? '' }) as string);
        } else {
            setGpsDeviceInactiveWarning(undefined);
        }
        // Task #66078: o GPS NUNCA escreve nos inputs de capacidade — o valor configurado no
        // provedor é mostrado apenas como aviso informativo por baixo do campo (ver render).
    }, [form.watch('trackingDeviceId'), trackingVehiclesById]);


    useEffect(() => {
        if (showField(SEGMENT_FEATURES.FUEL) && !form.getValues('vehicleFuels')?.length) {
            form.setValue('vehicleFuels', [{}]);
        }
    }, [segmentFeatures]);


    const showReplacementVehicleDialog = (_item: VehicleViewModel) => {
        setDialogReplacementVehicleIsOpen(true);
    };

    return (
        <form onSubmit={handleSubmit(onSubmit)}>
            <Box className={styles.box} style={{ boxShadow: !(mode != 'edit' && mode != 'details') ? 'none' : '' }}>
                {item && (mode == 'edit') && <div className={styles.header}>
                    <img src={IconBack} className={styles.icon} onClick={() => navigateTo()} /> {t('vehicle.car_document')}
                </div>}

                <div className={styles.content}>
                    <Row >
                        {(item?.timelineHistory && item?.timelineHistory.length > 0) &&
                            <>
                                <Row className={styles.fullWidth}>
                                    <div className={styles.section} style={{ cursor: 'pointer' }} onClick={() => { setReplacementVehiclesRowExpanded(!replacementVehiclesRowExpanded) }}>
                                        <div className={styles.sectionTitle} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}  >
                                            {t('vehicle.vehicle_history')}
                                            {replacementVehiclesRowExpanded ? <FaAngleUp color={colors.gray} /> : <FaAngleDown color={colors.gray} />}
                                        </div>
                                    </div>
                                </Row>
                                {replacementVehiclesRowExpanded &&
                                    <Row className={styles.fullWidth}>
                                        <ReplacementTimeline item={item} onVehicleUpdated={onVehicleUpdated} loadHistory={(id: string) => loadHistory(id)} />
                                    </Row>}
                            </>
                        }

                        <Row className={styles.fullWidth}>
                            <div className={styles.section}>
                                <div className={styles.sectionTitle}>
                                    {!item?.vehicleHistoryId && t('vehicle.vehicle_info')}
                                    {item?.vehicleHistoryId && 
                                        <div>
                                            <u>
                                                {t('vehicle.vehicle_info_history')}
                                                { item?.vehicleHistoryId && item.historyCreatedDate && <i><DateFormat value={item.historyCreatedDate} format={DATE_FORMAT_DEFAUT}></DateFormat></i> }
                                            </u>
                                        </div>
                                    }
                                    

                                    {/*item?.vehicleHistoryId && <span className={styles.iconCloseHistory} data-tip={t('vehicle.close_history_info')} data-for='close-btn'><ScreenHeaderButton  icon={CloseButtonGreen} onClick={resetItemToOriginal} /> 
                                        <ReactTooltip id='close-btn' />
                                    </span>*/}
                                    { item?.vehicleHistoryId && <Button
                                        type="button"
                                        size={'extraSmall'}
                                        text={t('common.back')}
                                        preset={'success'}
                                        onClick={() => resetItemToOriginal()} />}
                                </div>
                            </div>
                        </Row>

                        <Row className={styles.fullWidth}>

                            <Row className={styles.fullWidth}>
                                <Col xs={12} sm={12} lg={6} xl={3} >
                                    {/* foto */}
                                    <FormItem id="four-step" key={`reRenderPic_${item?.photoId}`}>
                                        <MediaSelector
                                            isMulti={false}
                                            isDetails={isDetails}
                                            onAddMedias={onAddMedias}
                                            onRemoveMedia={onRemoveMedia}
                                            initialMedias={item?.photo ?? []}
                                            label={t('vehicle.add_photo')}
                                            container={'vehiclePhoto'}
                                            vehicleIcon={true}
                                            defaultEmptyImageUrl={typesOptions.find(x => x.value == getValues('vehicleSegmentId'))?.vehicleSegmentDefaultPhotoUrl}
                                        />
                                    </FormItem>
                                </Col>

                                <Col xs={12} sm={12} lg={6} xl={9} >
                                    <Row>
                                        {/* tipo */}
                                        <Col xs={12} sm={12} md={6} xl={4}>
                                            <FormItem>
                                                <Label className={styles.label}>{t('vehicle.type')} *</Label>
                                                <SelectController
                                                    form={form}
                                                    name="vehicleSegmentId"
                                                    placeholder={t('vehicle.type')}
                                                    isDisabled={isDetails}
                                                    options={typesOptions}
                                                    rules={{ required: true }}
                                                    isClearable={true}
                                                    filterOption={(candidate: any, input: any) => input ? removeAccents(candidate.label).toUpperCase().includes(removeAccents(input).toUpperCase()) : true}
                                                    onChangeSelect={(data: SelectValueLabel) => {
                                                        setValue('vehicleSegmentId', data ? data.value : null);
                                                        getBrandsBySegment();
                                                    }}
                                                />
                                                <InputError error={errors.vehicleSegmentId} />
                                            </FormItem>
                                        </Col>

                                        {/* marca */}
                                        <Col xs={12} sm={12} md={6} xl={4}>
                                            <FormItem>
                                                <Label className={styles.label}>{t('vehicle.brand')}</Label>
                                                <SelectController
                                                    form={form}
                                                    name="vehicleBrandId"
                                                    placeholder={t('vehicle.brand')}
                                                    isDisabled={isDetails}
                                                    options={brandsOptions}
                                                    rules={{ required: false }}
                                                    isClearable={true}
                                                    filterOption={(candidate: any, input: any) => input ? removeAccents(candidate.label).toUpperCase().includes(removeAccents(input).toUpperCase()) : true}
                                                    onChangeSelect={(data: SelectValueLabel) => {
                                                        setValue('vehicleBrandId', data ? data.value : null);
                                                        getModelByBrand();
                                                    }}
                                                />
                                                <InputError error={errors.vehicleBrandId} />

                                            </FormItem>
                                        </Col>

                                        {/* modelo */}
                                        <Col xs={12} sm={12} md={6} xl={4}>
                                            <FormItem>
                                                <Label className={styles.label}>{t('vehicle.model')}</Label>
                                                <SelectController
                                                    form={form}
                                                    name="vehicleModelId"
                                                    placeholder={t('vehicle.model')}
                                                    isDisabled={isDetails}
                                                    options={modelsOptions}
                                                    rules={{ required: false }}
                                                    isClearable={true}
                                                    filterOption={(candidate: any, input: any) => input ? removeAccents(candidate.label).toUpperCase().includes(removeAccents(input).toUpperCase()) : true}
                                                    onChangeSelect={(data: SelectValueLabel) => {
                                                        setValue('vehicleModelId', data ? data.value : null);
                                                        getBrandByModel();
                                                    }}
                                                />
                                                <InputError error={errors.vehicleModelId} />
                                            </FormItem>
                                        </Col>

                                        {/* matricula */}
                                        <Col xs={12} sm={12} md={6} xl={4}>
                                            <FormItem>
                                                <Label className={styles.label}>{showField(SEGMENT_FEATURES.KM) ? t('vehicle.registration') : t('vehicle.identification')} *</Label>
                                                <InputController
                                                    name="registrationNumber"
                                                    form={form as any}
                                                    autoComplete='off'
                                                    placeholder={showField(SEGMENT_FEATURES.KM) ? t('vehicle.registration') : t('vehicle.identification')}
                                                    rules={{ ...DEFAULT_INPUT_RULES_WITH_REQUIRED }}
                                                    className={registrationAlreadyExists ? styles.warningInput : ''}
                                                    disabled={isDetails}
                                                />
                                                <InputError error={errors.registrationNumber} />
                                                {!!registrationAlreadyExists && registrationAlreadyExists == form.getValues('registrationNumber') && <div className={styles.warningLabel}>{showField(SEGMENT_FEATURES.KM) ? t('common.messages.registration_number_already_exists') : t('common.messages.indentification_number_already_exists')}</div>}
                                            </FormItem>
                                        </Col>

                                        {/* data matricula */}
                                        {showField(SEGMENT_FEATURES.KM) && <Col xs={12} sm={12} md={6} xl={4}>
                                            <FormItem>
                                                <Label className={styles.label}>{t('vehicle.registration_date')}</Label>
                                                <DateTimePickerController
                                                    form={form}
                                                    placeholderText={t('vehicle.registration_date')}
                                                    onChange={(date: Date) => {
                                                        setValue('registrationNumberDate', date);
                                                    }}
                                                    selected={watch('registrationNumberDate')}
                                                    dateFormat="MM/yyyy"
                                                    customInput={<InputGroup icon={<FaCalendarAlt />} />}
                                                    name="registrationNumberDate"
                                                    autoComplete='off'
                                                    showMonthYearPicker
                                                    disabled={isDetails}
                                                />
                                                <InputError error={errors.registrationNumberDate} />
                                            </FormItem>
                                        </Col>}


                                        {/* data circulacao */}
                                        {showField(SEGMENT_FEATURES.KM) && <Col xs={12} sm={12} md={6} xl={4}>
                                            <FormItem>
                                                <Label className={styles.label}>{t('vehicle.date_circulation')}</Label>
                                                <DateTimePickerController
                                                    form={form}
                                                    placeholderText={t('vehicle.date_circulation')}
                                                    // eslint-disable-next-line @typescript-eslint/no-empty-function
                                                    onChange={() => { }}
                                                    selected={watch('dateCirculation') != undefined ? new Date(watch('dateCirculation')!) : null}

                                                    dateFormat="DD/MM/yyyy"
                                                    customInput={<InputGroup icon={<FaCalendarAlt />} />}
                                                    name="dateCirculation"
                                                    autoComplete='off'
                                                    rules={{ required: false }}
                                                    disabled={isDetails}
                                                />
                                            </FormItem>
                                        </Col>}


                                    </Row>
                                </Col>
                            </Row>

                            <Row className={styles.fullWidth}>
                                <Col xs={12} sm={12} lg={6} xl={3} >
                                    {/* QRCode */}
                                    <FormItem>
                                        <QrCode value={form.watch('registrationNumber')} label={showField(SEGMENT_FEATURES.KM) ? t('vehicle.registration_qrCode') : t('vehicle.identification_qrCode')}
                                            emptyMessage={showField(SEGMENT_FEATURES.KM) ? t('vehicle.add_registration') : t('vehicle.add_identification')} />
                                    </FormItem>
                                </Col>

                                <Col xs={12} sm={12} lg={6} xl={9}>
                                    <Row>

                                        {/* condicao */}
                                        <Col xs={12} sm={12} md={6} xl={4}>
                                            <FormItem>
                                                <Label className={styles.label}>{t('vehicle.condition')} *</Label>
                                                <div className={styles.condition} style={{ cursor: mode !== 'details' ? 'pointer' : 'not-allowed' }}>
                                                    {conditionsOptions.map((c, i) => {
                                                        const isSelected = c === selectedCondition ? true : false;
                                                        const label = c ? t(('vehicle.conditions.' + c) as any) : '';
                                                        return renderConditionItem(label, () => onSelectCondition(c), isSelected, i);

                                                    })}
                                                </div>

                                                {(!conditionIsSelected) && <label className={styles.errorLabel}>
                                                    {t('common.errors.required')}
                                                </label>}

                                            </FormItem>
                                        </Col>

                                        {/* cor */}
                                        <Col xs={12} sm={12} md={6} xl={4}>
                                            <FormItem>
                                                <Label className={styles.label}>{t('vehicle.color')}</Label>
                                                <SelectController
                                                    form={form}
                                                    name="colorId"
                                                    placeholder={t('vehicle.color')}
                                                    isDisabled={isDetails}
                                                    options={colorsOptions}
                                                    rules={{ required: false }}
                                                    isClearable={true}
                                                    filterOption={(candidate: any, input: any) => input ? removeAccents(candidate.label).toUpperCase().includes(removeAccents(input).toUpperCase()) : true}
                                                    onChangeSelect={(data: SelectValueLabel) => {
                                                        setValue('colorId', data ? data.value : null);
                                                    }}
                                                />
                                                <InputError error={errors.colorId} />
                                            </FormItem>
                                        </Col>

                                        {/* Moyenne objectif mois */}
                                        {showField(SEGMENT_FEATURES.KM) && <Col xs={12} sm={12} md={6} xl={4}>
                                            <FormItem>
                                                <Label className={styles.label}>{t('vehicle.average_target_month')}</Label>
                                                <Controller
                                                    render={({ }) => {
                                                        return (
                                                            <InputGroup
                                                                style={{ textAlign: 'end' }} format={'number'}
                                                                placeholder={t('vehicle.average_target_month')}
                                                                text={t('vehicle.km')}
                                                                value={form.getValues('averageTargetMonth')}
                                                                onValueChange={value => {
                                                                    setValue('averageTargetMonth', value);
                                                                }}
                                                                disabled={isDetails} />
                                                        );
                                                    }}
                                                    control={control}
                                                    name="averageTargetMonth"
                                                    defaultValue={form.getValues('averageTargetMonth')}
                                                />
                                            </FormItem>
                                        </Col>}
                                        {showField(SEGMENT_FEATURES.HOURS) && <Col xs={12} sm={12} md={6} xl={4}>
                                            <FormItem>
                                                <Label className={styles.label}>{t('vehicle.average_target_month_hours')}</Label>
                                                <Controller
                                                    render={({ }) => {
                                                        return (
                                                            <InputGroup
                                                                style={{ textAlign: 'end' }} format={'number'}
                                                                placeholder={t('vehicle.average_target_month_hours')}
                                                                text={t('common.hours_symbol')}
                                                                value={form.getValues('averageTargetMonthHours')}
                                                                onValueChange={value => {
                                                                    setValue('averageTargetMonthHours', value);
                                                                }}
                                                                disabled={isDetails} />
                                                        );
                                                    }}
                                                    control={control}
                                                    name="averageTargetMonthHours"
                                                    defaultValue={form.getValues('averageTargetMonthHours')}
                                                />
                                            </FormItem>
                                        </Col>}
                                    </Row>
                                </Col>
                            </Row>

                            <Row className={styles.fullWidth}>
                                {/* poder fiscal */}
                                {showField(SEGMENT_FEATURES.KM) && <Col xs={12} sm={12} md={6} xl={3}>
                                    <FormItem>
                                        <Label className={styles.label}>{t('vehicle.fiscal_power')}</Label>
                                        <InputController
                                            name="fiscalPower"
                                            form={form as any}
                                            autoComplete='off'
                                            placeholder={t('vehicle.fiscal_power')}
                                            disabled={isDetails}
                                        />
                                    </FormItem>
                                </Col>}

                                {/* capacidade do deposito (litros) - #66078 */}
                                {showField(SEGMENT_FEATURES.FUEL) && (hasNonElectricFuel || !hasElectricFuel) && <Col xs={12} sm={12} md={6} xl={3}>
                                    <FormItem>
                                        <Label className={styles.label}>{t('vehicle.tank_capacity') as string}</Label>
                                        <Controller
                                            render={({ }) => {
                                                return (
                                                    <InputGroup
                                                        style={{ textAlign: 'end' }} format={'number'}
                                                        placeholder={t('vehicle.tank_capacity') as string}
                                                        text={t('common.lt') as string}
                                                        value={form.getValues('tankCapacity')}
                                                        onValueChange={value => {
                                                            setValue('tankCapacity', value);
                                                        }}
                                                        disabled={isDetails} />
                                                );
                                            }}
                                            control={control}
                                            name="tankCapacity"
                                            defaultValue={form.getValues('tankCapacity')}
                                        />
                                    </FormItem>
                                </Col>}

                                {/* capacidade da bateria (kWh) - so eletrico - #66078 */}
                                {showField(SEGMENT_FEATURES.FUEL) && hasElectricFuel && <Col xs={12} sm={12} md={6} xl={3}>
                                    <FormItem>
                                        <Label className={styles.label}>{t('vehicle.battery_capacity_kwh') as string}</Label>
                                        <Controller
                                            render={({ }) => {
                                                return (
                                                    <InputGroup
                                                        style={{ textAlign: 'end' }} format={'number'}
                                                        placeholder={t('vehicle.battery_capacity_kwh') as string}
                                                        text={t('common.kwh') as string}
                                                        value={form.getValues('batteryCapacityKwh')}
                                                        onValueChange={value => {
                                                            setValue('batteryCapacityKwh', value);
                                                        }}
                                                        disabled={isDetails} />
                                                );
                                            }}
                                            control={control}
                                            name="batteryCapacityKwh"
                                            defaultValue={form.getValues('batteryCapacityKwh')}
                                        />
                                    </FormItem>
                                </Col>}

                                {/* limite de kms/dia - #66078 */}
                                {showField(SEGMENT_FEATURES.KM) && <Col xs={12} sm={12} md={6} xl={3}>
                                    <FormItem>
                                        <Label className={styles.label}>{t('vehicle.daily_km_limit') as string}</Label>
                                        <Controller
                                            render={({ }) => {
                                                return (
                                                    <InputGroup
                                                        style={{ textAlign: 'end' }} format={'number'}
                                                        placeholder={t('vehicle.daily_km_limit') as string}
                                                        text={t('vehicle.km') as string}
                                                        value={form.getValues('dailyKmLimit')}
                                                        onValueChange={value => {
                                                            setValue('dailyKmLimit', value);
                                                        }}
                                                        disabled={isDetails} />
                                                );
                                            }}
                                            control={control}
                                            name="dailyKmLimit"
                                            defaultValue={form.getValues('dailyKmLimit')}
                                        />
                                    </FormItem>
                                </Col>}

                                {/* disponivel para reservar */}
                                <Col xs={12} sm={12} md={6} xl={3}>
                                    <FormItem>
                                        <Label className={styles.label}>{t('vehicle.available_for_reservation')}</Label>
                                        <ToggleSwitch
                                            name="reservationAvailable"
                                            form={form}
                                            isDetails={isDetails}
                                        />
                                    </FormItem>
                                </Col>

                                {/* condutor por defeito */}
                                <Col xs={12} sm={12} md={6} xl={3}>
                                    <FormItem>
                                        <Label className={styles.label}>{t('vehicle.default_driver')}</Label>
                                        <SelectController
                                            form={form}
                                            name="defaultDriverId"
                                            placeholder={t('vehicle.default_driver')}
                                            isDisabled={isDetails || !!form.watch('reservationAvailable')}
                                            options={driversOptionsWithCurrent}
                                            isClearable={true}
                                            filterOption={(candidate: any, input: any) => input ? removeAccents(candidate.label).toUpperCase().includes(removeAccents(input).toUpperCase()) : true}
                                            onChangeSelect={(data: SelectValueLabel) => {
                                                setValue('defaultDriverId', data ? data.value : null);
                                            }}
                                        />
                                    </FormItem>
                                </Col>


                                {/* agência */}
                                <Col xs={12} sm={12} md={6} xl={3}>
                                    <FormItem>
                                        <Label className={styles.label}>{t('vehicle.locals')}</Label>
                                        <Controller
                                            render={({ onChange, value }) => {
                                                return (
                                                    <Select
                                                        options={localsOptions}
                                                        isClearable
                                                        isMulti
                                                        isDisabled={isDetails}
                                                        placeholder={t('vehicle.locals')}
                                                        onChange={(data: SelectValueLabel[]) => {
                                                            onChange(data?.map(x => ({ localId: x.value })));
                                                        }}
                                                        value={value ? localsOptions.filter(x => value.find((y: LocalBasicInfoViewModel) => y.localId === x.value)) : null}
                                                    />
                                                );
                                            }}
                                            control={control}
                                            name="vehicleLocals"
                                            defaultValue={getValues('vehicleLocals')} />
                                        <InputError error={errors.vehicleLocals as any} />
                                    </FormItem>
                                </Col>

                                {/* cartao combustivel */}
                                {showField(SEGMENT_FEATURES.FUEL) && <Col xs={12} sm={12} md={6} xl={3}>
                                    <FormItem>
                                        <Label className={styles.label}>{t('vehicle.fuel_card')}</Label>
                                        <Input
                                            name="fuelCard"
                                            placeholder={t('vehicle.fuel_card')}
                                            ref={register()}
                                            autoComplete='off'
                                            disabled={isDetails}
                                        />
                                    </FormItem>
                                </Col>}

                                {showField(SEGMENT_FEATURES.FUEL) && <Col xs={12} sm={12} md={6} xl={3}>
                                    <FormItem>
                                        <Label className={styles.label}>{t('vehicle.fuel_card_supplier')}</Label>
                                        <SelectController
                                            form={form}
                                            name="fuelCardSupplierId"
                                            placeholder={t('vehicle.supplier')}
                                            isDisabled={isDetails}
                                            options={fuelSuppliersOptions}
                                            isClearable={true}
                                            filterOption={(candidate: any, input: any) => input ? removeAccents(candidate.label).toUpperCase().includes(removeAccents(input).toUpperCase()) : true}
                                            onChangeSelect={(data: SelectValueLabel) => {
                                                setValue('fuelCardSupplierId', data ? data.value : null);
                                            }}
                                        />
                                    </FormItem>
                                </Col>}

                                {gpsLocatorsOptions && gpsLocatorsOptions.length > 0 &&
                                    <>
                                        <Col xs={12} sm={12} md={6} xl={3}>
                                            <FormItem>
                                                <Label className={styles.label}>{t('vehicle.gps_locator')}</Label>
                                                <SelectController
                                                    form={form}
                                                    name="gpsLocatorId"
                                                    placeholder={t('vehicle.gps_locator')}
                                                    isDisabled={isDetails}
                                                    options={gpsLocatorsOptions}
                                                    isClearable={true}
                                                    filterOption={(candidate: any, input: any) => input ? removeAccents(candidate.label).toUpperCase().includes(removeAccents(input).toUpperCase()) : true}
                                                />
                                            </FormItem>
                                        </Col>

                                        <Col xs={12} sm={12} md={6} xl={3}>
                                            <FormItem>
                                                <Label className={styles.label}>{t('vehicle.tracking_device')}</Label>
                                                {!isLoadingVehicles && <SelectController
                                                    form={form}
                                                    name="trackingDeviceId"
                                                    placeholder={t('vehicle.tracking_device')}
                                                    isDisabled={isDetails}
                                                    options={trackingVehiclesOptions}
                                                    isClearable={true}
                                                    filterOption={(candidate: any, input: any) => input ? removeAccents(candidate.label).toUpperCase().includes(removeAccents(input).toUpperCase()) : true}
                                                />}
                                                {isLoadingVehicles && <LoadingSpinner />}
                                                {!!gpsDeviceConflictMessage && <div className={styles.warningLabel}>{gpsDeviceConflictMessage}</div>}
                                                {!gpsDeviceConflictMessage && !!gpsDeviceInactiveWarning && <div className={styles.warningLabel}>{gpsDeviceInactiveWarning}</div>}
                                            </FormItem>
                                        </Col>
                                    </>}

                                    {/* matricula */}
                                    {item?.vehicleHistoryId && <Col xs={12} sm={12} md={6} xl={3}>
                                        <FormItem>
                                            <Label className={styles.label}>{t('vehicle.vehicle_status')}</Label>
                                            <InputController
                                                name="activeDescription"
                                                form={form as any}
                                                autoComplete='off'
                                                placeholder={t('vehicle.vehicle_status')}
                                                rules={{ ...DEFAULT_INPUT_RULES_WITH_REQUIRED }} 
                                                disabled={isDetails} 
                                            />
                                            <InputError error={errors.registrationNumber} />
                                            {!!registrationAlreadyExists && registrationAlreadyExists == form.getValues('registrationNumber') && <div className={styles.warningLabel}>{showField(SEGMENT_FEATURES.KM) ? t('common.messages.registration_number_already_exists') : t('common.messages.indentification_number_already_exists')}</div>}
                                        </FormItem>
                                    </Col>}

                                <AdditionalDataForm form={form}
                                    xs={12} sm={12} md={6} xl={3}
                                    initial={initial}
                                    isDetails={isDetails} />

                            </Row>
                        </Row>
                        {!item?.vehicleHistoryId && showField(SEGMENT_FEATURES.FUEL) && <Row className={styles.fullWidth}>
                            <VehicleFuelForm
                                form={form}
                                isDetails={isDetails}
                                mode={mode}
                                fuelsOptions={fuelsOptions}
                            />
                        </Row>}

                        {!item?.vehicleHistoryId && <Row className={styles.fullWidth}>
                            <TechnicalInformationForm
                                form={form}
                                isDetails={isDetails}
                                onRemoveTechnicalInformation={onRemoveTechnicalInformation}
                            />
                        </Row>}
                    </Row>
                </div>

                {!item?.vehicleHistoryId && <div className={styles.buttonsContainer}>
                    {item && isDetails && hasVehiclesWritePolicy && (item.immobilized || !item.active) && !item.replacedVehicle && (
                        <Button
                            type="button"
                            text={t('replacement_vehicles.replace')}
                            preset={'secondary-success'}
                            onClick={() => showReplacementVehicleDialog({ id: item?.id } as VehicleViewModel)}
                        />
                    )}
                    {item && isDetails && hasVehiclesWritePolicy && item.replacedVehicle && (
                        <Button
                            type="button"
                            text={t('replacement_vehicles.finish_replacement')}
                            preset={'secondary'}
                            onClick={() => showReplacementVehicleDialog({ id: item?.id } as VehicleViewModel)}
                        />
                    )}
                   
                    {(returnUrl || mode === 'edit') && <Button
                        preset={'secondary'}
                        type="button"
                        onClick={() => navigateTo()}
                        text={t('common.cancel')}
                    />}
                    {item && item.active && isDetails && hasVehiclesWritePolicy && <Button
                        type="button"
                        text={t('common.deactivate')}
                        preset={'danger'}
                        onClick={() => showRemoveItemDialog({ id: item?.id } as VehicleViewModel)} />}


                    {item && !item.active && isDetails && hasVehiclesWritePolicy &&

                        <Button
                            type="button"
                            text={t('common.activate')}
                            preset={'primary'}
                            onClick={() => showActivateItemDialog({ id: item?.id } as VehicleViewModel)} />
                    }

                   

                    {mode === ('details') && item && item.active && hasVehiclesWritePolicy &&
                        <Button
                            type={'button'}
                            text={t('common.edit')}
                            onClick={() => { navigateTo('edit', item?.id); }}
                        />}

                    {hasVehiclesWritePolicy && mode !== ('details') && <Button
                        type={'submit'}
                        text={t('common.save')}
                    />}

                    {!item?.replacedVehicle ? <VehicleActivationModal
                        isVisible={dialogDeleteItemIsOpen}
                        isToActivate={false}
                        onCancel={() => setDialogDeleteItemIsOpen(false)}
                        onDeactivate={() => removeItem()}
                        onDeactivateAndReplace={() => { deactivateAndReplaceItem() }} />
                        :
                        <QuestionYesNo
                            isVisible={dialogDeleteItemIsOpen}
                            onYes={() => removeItem()}
                            onNo={() => setDialogDeleteItemIsOpen(false)} >
                            <div>
                                <span>{t('common.messages.deactivate_record')}</span>
                            </div>
                        </QuestionYesNo>
                    }


                    {item?.replacedVehicle ? <VehicleActivationModal
                        isVisible={dialogActivateItemIsOpen}
                        isToActivate={true}
                        onCancel={() => setDialogActivateItemIsOpen(false)}
                        onActivate={() => activateItem()}
                        onActivateAndFinishReplace={() => { activateAndFinishReplaceItem() }} />
                        :
                        <QuestionYesNo
                            isVisible={dialogActivateItemIsOpen}
                            onYes={() => activateItem()}
                            onNo={() => setDialogActivateItemIsOpen(false)} >
                            <div>
                                <span>{t('common.messages.activate_record')}</span>
                            </div>
                        </QuestionYesNo>
                    }

                    <QuestionYesNo
                        isVisible={dialogQuestionFinishReplacementVehicleIsOpen}
                        onYes={() => { setDialogQuestionFinishReplacementVehicleIsOpen(false); setDialogReplacementVehicleIsOpen(true) }}
                        onNo={() => { setDialogQuestionFinishReplacementVehicleIsOpen(false); onVehicleUpdated && onVehicleUpdated(); }} >
                        <div>
                            <span> {t('replacement_vehicles.vehicle_finish_deactivated')}</span> <br />
                            <span> {t('replacement_vehicles.finish_replacement_vehicle')}</span>
                        </div>
                    </QuestionYesNo>

                    <VehicleReplacementModal
                        isVisible={dialogReplacementVehicleIsOpen}
                        currentVehicle={item as any}
                        replacedVehicle={item?.replacedVehicle ? item?.id : undefined}
                        onSave={() => {
                            setDialogReplacementVehicleIsOpen(false);
                            onVehicleUpdated && onVehicleUpdated();
                        }}
                        onCancel={() => setDialogReplacementVehicleIsOpen(false)}
                    />
                </div>}
            </Box>
        </form >
    );
}

export default CarForm;